import router from '@/router';
import store from '@/store';

export function logout() {
  store.dispatch('account/clearAll');
  router.push({
    name: 'account-login',
  });
}
